import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import * as CheckoutActions from './checkout.actions';
import * as fromCheckout from './checkout.reducers';
import * as CheckoutSelectors from './checkout.selectors';
import { APIService } from '../../services/api/api-service';
import { NewOrderDTO, IAddress } from '@care-portals/api-interfaces';

@Injectable()
export class CheckoutFacade {
  loading$ = this.store.select(CheckoutSelectors.selectLoading);
  saving$ = this.store.select(CheckoutSelectors.selectSaving);
  orderId$ = this.store.select(CheckoutSelectors.selectOrderId);
  error$ = this.store.select(CheckoutSelectors.selectError);
  addresses$ = this.store.select(CheckoutSelectors.selectAddresses);
  cart$ = this.store.select(CheckoutSelectors.selectCart);
  coupon$ = this.store.select(CheckoutSelectors.selectCoupon);
  orderItems$ = this.store.select(CheckoutSelectors.selectOrderItems);

  constructor(
    private store: Store<fromCheckout.State>,
    private api: APIService
  ) {}

  loadCart(id: string) {
    this.store.dispatch(CheckoutActions.loadCart({ cartId: id }));
    return this.cart$;
  }

  linkCartToCustomer(id: string) {
    this.store.dispatch(CheckoutActions.linkCartToCustomer({ cartId: id }));
  }

  loadAddresses() {
    this.store.dispatch(CheckoutActions.loadAddresses());
  }

  addAddress(address: IAddress) {
    this.store.dispatch(CheckoutActions.addAddress({ address }));
  }

  createOrder(newOrder: NewOrderDTO) {    
    return this.store.dispatch(CheckoutActions.createOrder({ newOrder }));
  }

  applyCoupon(code: string) {
    return this.store.dispatch(CheckoutActions.applyCoupon({ code }));
  }

  clearCoupon() {
    return this.store.dispatch(
      CheckoutActions.applyCouponSuccess({ coupon: null })
    );
  }

  // setShippingAddress(cartId: string, address: IAddress) {
  //   return this.store.dispatch(CheckoutActions.setShippingAddress({ cartId, address }))
  // }
}
